import { AxiosStatic } from "axios";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";

import { PpqModel } from "./models";

export class PpqApi {
    private readonly apiUrl = "/api/ppq";

    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async get(ohCaseId: string): Promise<PpqModel> {
        const response = await this.axios.get(`${this.apiUrl}/${ohCaseId}`);
        return response.data;
    }

    public async getUnmatched(customerId: string, ppqId: string) {
        const response = await this.axios.get(`${this.apiUrl}/${customerId}/${ppqId}`);
        return response.data;
    }

    public async create(customerId: string, employeeId: string, managerFormData: AnsweredQuestionWithId[], employeeFormData: AnsweredQuestionWithId[]) {
        const response = await this.axios.post(
            `/api/customer/${customerId}/employeeRecord/${employeeId}/ppqCase`,
            { managerFormData: { questions: managerFormData }, employeeFormData: { questions: employeeFormData } });
        return response.data;
    }
}
